import React, { useState, useEffect, useRef  } from 'react';
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import * as parameterHelper from '../shared/extraParameterHelper';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import ShowError from "../shared/ShowError";
import { Col, Container, Row, Table } from 'react-bootstrap';
import { RadioButton } from 'primereact/radiobutton';
import CityCombo from '../combos/CityCombo';
import { Checkbox } from 'primereact/checkbox';

export default function PromoteContractParameters(props) {
    const navigate = useNavigate();
    const [contract, setContract] = useState(null);
    const [parameterType1, setParameterType1] = useState(0);
    const [parameterType2, setParameterType2] = useState(0);
    const [parameterValue1, setParameterValue1] = useState(0);
    const [parameterValue2, setParameterValue2] = useState(0);
    const [parameterNewValue1, setParameterNewValue1] = useState(0);
    const [parameterNewValue2, setParameterNewValue2] = useState(0);
    const [parameterCaption1, setParameterCaption1] = useState(0);
    const [parameterCaption2, setParameterCaption2] = useState(0);
    const [oldPrice, setOldPrice] = useState(0);
    const [parameterPrice, setParameterPrice] = useState(0);
    const [tax, setTax] = useState(0);
    const [purePrice, setPurePrice] = useState(0);
    const [extraParameters, setExtraParameters] = useState(0);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const targetRef1 = useRef(null);

    useEffect(() => {
        util.scrollToElement(targetRef1, "start");
         var params = {param1:"1", param2:"", param3:"", param4:"", param5:""};
        var url = config.Server+`/basic/product-prices/list`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("resopnse is> ", response);
                var ps = response;
                setExtraParameters(ps.extraParameters);
                loadContractParams(ps.extraParameters);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });
       
    }, []);
    const loadContractParams = function(exParameters){
        var contract = util.getClientContract();
        var buy = util.getBuy();
        console.log("contract in promote params is>", contract);
        console.log("buy in promote params is>", buy);

        var oPrice = 0;
        var price = 0;
        if(contract.contract.product.productType.id == util.ProductTypes.WinHanaAccounting){
            setParameterType1(util.ContractParameterTypes.MaxClientNo);
            setParameterCaption1("حداکثر تعداد دستگاه نصب");
            setParameterType2(util.ContractParameterTypes.MaxVisitorNo);
            setParameterCaption2("حداکثر تعداد ویزیتور");
            var pv1 = 0;
            var pv2 = 0;
            for(var i=0;i<contract.contract.parameters.length;i++){
                var p = contract.contract.parameters[i];
                console.log("p in loop is>", p)
                if(p.parameterType.id == util.ContractParameterTypes.MaxClientNo){
                    pv1 = p.intValue;
                    setParameterValue1(pv1);
                }
                else if(p.parameterType.id == util.ContractParameterTypes.MaxVisitorNo){
                    pv2 = p.intValue;
                    setParameterValue2(pv2);
                }
            }
            if(buy != null){
                var npv1 = buy.parameters.maxClientNo;
                var npv2 = buy.parameters.maxVisitorNo;
                setParameterNewValue1(npv1);
                setParameterNewValue2(npv2);
                if(npv1 < pv1) npv1 = pv1;
                if(npv2 < pv2) npv2 = pv2;
                price = parameterHelper.getWinHanaAccountingParameterPrice(npv1, npv2, exParameters);
            }

            oPrice = parameterHelper.getWinHanaAccountingParameterPrice(pv1, pv2, exParameters);
        }
        else if(contract.contract.product.productType.id == util.ProductTypes.SchoolManagment){
            setParameterType1(util.ContractParameterTypes.MaxStudentNo);
            setParameterCaption1("حداکثر تعداد دانش آموز");
            setParameterType2(util.ContractParameterTypes.MaxSchoolNo);
            setParameterCaption2("حداکثر تعداد مدرسه");
            var pv1 = 0;
            var pv2 = 0;
            for(var i=0;i<contract.contract.parameters.length;i++){
                var p = contract.contract.parameters[i];
                if(p.parameterType.id == util.ContractParameterTypes.MaxStudentNo){
                    pv1 = p.intValue;
                    setParameterValue1(pv1);
                }
                else if(p.parameterType.id == util.ContractParameterTypes.MaxSchoolNo){
                    pv2 = p.intValue;
                    setParameterValue2(pv2);
                }
            }
            if(buy != null){
                var npv1 = buy.parameters.maxStudentNo;
                var npv2 = buy.parameters.maxSchoolNo;
                setParameterNewValue1(npv1);
                setParameterNewValue2(npv2);
                if(npv1 < pv1) npv1 = pv1;
                if(npv2 < pv2) npv2 = pv2;
                price = parameterHelper.getSchoolManagementParameterPrice(npv1, npv2, exParameters);
            }
            oPrice = parameterHelper.getSchoolManagementParameterPrice(pv1, pv2, exParameters);
        }
        else if(contract.contract.product.productType.id == util.ProductTypes.SandooghManagment){
            setParameterType1(util.ContractParameterTypes.MaxMemberNo);
            setParameterCaption1("حداکثر تعداد عضو");
            var pv1 = 0;
            for(var i=0;i<contract.contract.parameters.length;i++){
                var p = contract.contract.parameters[i];
                if(p.parameterType.id == util.ContractParameterTypes.MaxMemberNo){
                    pv1 = p.intValue;
                    setParameterValue1(pv1);
                }
            }
            if(buy != null){
                var npv1 = buy.parameters.maxMemberNo;
                setParameterNewValue1(npv1);
                if(npv1 < pv1) npv1 = pv1;
                price = parameterHelper.getSandooghManagementParameterPrice(npv1, exParameters);
            }
            oPrice = parameterHelper.getSandooghManagementParameterPrice(pv1, exParameters);
        }
        else if(contract.contract.product.productType.id == util.ProductTypes.TaxSerivce){
            setParameterType1(util.ContractParameterTypes.MaxBillNo);
            setParameterCaption1("حداکثر تعداد صورتحساب در سال");
            var pv1 = 0;
            for(var i=0;i<contract.contract.parameters.length;i++){
                var p = contract.contract.parameters[i];
                if(p.parameterType.id == util.ContractParameterTypes.MaxBillNo){
                    pv1 = p.intValue;
                    setParameterValue1(pv1);
                }
            }
            if(buy != null){                
                var npv1 = buy.parameters.maxBillNo;
                if(npv1 < pv1) npv1 = pv1;
                setParameterNewValue1(npv1);
                price = parameterHelper.getTaxServiceParameterPrice(npv1, exParameters);
            }
            oPrice = parameterHelper.getTaxServiceParameterPrice(pv1, exParameters);
        }
        console.log("(price, oldPrice)->", price, oPrice)
        setOldPrice(oPrice);

        price -= oPrice;
        if(price < 0) price = 0;

        setParameterPrice(price);
        var tx = Math.floor((price * contract.taxPercent)/100);
        setTax(tx);
        setPurePrice(price + tx);
        setContract(contract);
    }
    const checkDataEntry = function(){
        if((parameterNewValue1 == 0)&&(parameterNewValue2 == 0)){
            setErorVisible(true);
            setErrorMessage("هیچ مقداری تنظیم نشده است");
            return false;
        }
        if((parameterNewValue1 > 0)&&(parameterNewValue1<=parameterValue1)){
            setErorVisible(true);
            setErrorMessage("مقدار تنطیم شده باید بیشتر از مقدار فعلی باشد");
            return false;
        }
        if((parameterNewValue2 > 0)&&(parameterNewValue2<=parameterValue2)){
            setErorVisible(true);
            setErrorMessage("مقدار تنطیم شده باید بیشتر از مقدار فعلی باشد");
            return false;
        }
        return true;
    }
    const onContinueButtonClick = function(){
        if(!checkDataEntry()) return;

        var maxClientNo = 0;
        var maxVisitorNo = 0;
        var maxStudentNo = 0;
        var maxSchoolNo = 0;
        var maxMemberNo = 0;
        var maxBillNo = 0;
        if(contract.contract.product.productType.id == util.ProductTypes.WinHanaAccounting){
            maxClientNo = parameterNewValue1;
            maxVisitorNo = parameterNewValue2;
        }
        else if(contract.contract.product.productType.id == util.ProductTypes.SchoolManagment){
            maxStudentNo = parameterNewValue1;
            maxSchoolNo = parameterNewValue2;
        }
        else if(contract.contract.product.productType.id == util.ProductTypes.SandooghManagment){
            maxMemberNo = parameterNewValue1;
        }
        else if(contract.contract.product.productType.id == util.ProductTypes.TaxSerivce){
            maxBillNo = parameterNewValue1;
        }
        var buy = {
            productId:contract.contract.id,
            enName:contract.contract.product.enName,
            buyGoal:"promoteParameter",
            productType:0,
            modules:[],
            parameters :{
                maxClientNo:maxClientNo,
                maxVisitorNo:maxVisitorNo,
                maxStudentNo:maxStudentNo,
                maxSchoolNo:maxSchoolNo,
                maxMemberNo:maxMemberNo,
                maxBillNo:maxBillNo
            },
            price:purePrice,
            discountToken:"",
            discountMobile:"",

        };
        util.saveBuy(buy);        
        
        util.saveIpgTransactionAmount(purePrice);
        util.saveIpgTransactionType(util.WallerTransactionTypes.PromoteContractParameter);
        util.saveBeforeIpgUrl("PromoteContractParameter");
        setRedirectUrl("/ipg/select");
    }
    const onParameterChanged = (value, ind) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        var price = 0;
        if(contract.contract.product.productType.id == util.ProductTypes.WinHanaAccounting){
            var pv1 = 0;
            var pv2 = 0;
            if(ind == 1) {
                pv1 = v;
                setParameterNewValue1(v);
                pv2 = parameterValue2;
            }
            else {
                pv2 = v;
                setParameterNewValue2(v);
                pv1 = parameterValue1;
            }
            price = parameterHelper.getWinHanaAccountingParameterPrice(pv1, pv2, extraParameters);
        }
        else if(contract.contract.product.productType.id == util.ProductTypes.SchoolManagment){
            var pv1 = 0;
            var pv2 = 0;
            if(ind == 1) {
                pv1 = v;
                setParameterNewValue1(v);
                setParameterNewValue2(0);
                pv2 = parameterValue2;
            }
            else {
                pv2 = v;
                setParameterNewValue1(0);
                setParameterNewValue2(v);
                pv1 = parameterValue1;
            }
            price = parameterHelper.getSchoolManagementParameterPrice(pv1, pv2, extraParameters);
        }
        else if(contract.contract.product.productType.id == util.ProductTypes.SandooghManagment){
            var pv1 = v;
            setParameterNewValue1(v);
            var price = parameterHelper.getSandooghManagementParameterPrice(pv1, extraParameters);
        }
        else if(contract.contract.product.productType.id == util.ProductTypes.TaxSerivce){
            var pv1 = v;
            setParameterNewValue1(v);
            var price = parameterHelper.getTaxServiceParameterPrice(pv1, extraParameters);
        }
        price -= oldPrice;
        if(price < 0) price = 0;

        setParameterPrice(price);
        var tx = Math.floor((price * contract.taxPercent)/100);
        setTax(tx);
        setPurePrice(price + tx);
        setContract(contract);
    }

    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        contract == null?
        <>
            بارگذاری قرارداد...
        </>
        :
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}} ref={targetRef1}>                
                <Col className="d-flex justify-content-center align-items-center" style={{marginBottom:"150px"}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px", position:"relative"}}>
                        <img src={require("../lib/images/back.png")} alt='برگشت' onClick={()=>{navigate("/my-contracts/list")}} style={{width:"48px", height:"32px", position:"absolute", top:"5px", right:"10px", cursor:"pointer"}} />
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                            <tbody>
                                <tr>
                                    <td style={{width:"100%", textAlign:"center"}} colSpan={2}>
                                        <img src={require('../lib/images/hana.webp')} style={{width:"64px"}} />
                                        {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center"}} colSpan={2}>تنظیم پارامترها جهت ارتقاء قرارداد</td>
                                </tr>
                                <tr><td colSpan={2}>&nbsp;</td></tr>
                                <tr><td colSpan={2}>&nbsp;</td></tr>
                                <tr>
                                    <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0"}}>
                                        نام پارمتر
                                    </td>
                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", fontWeight:"bold"}}>
                                        {parameterCaption1}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0"}}>
                                        مقدار فعلی
                                    </td>
                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0"}}>
                                        {parameterValue1}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0"}}>
                                        مقدار جدید
                                    </td>
                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0"}}>
                                        <InputText value={parameterNewValue1} onChange={(e) => onParameterChanged(e.target.value, 1)} onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={4} />
                                    </td>
                                </tr>
                                {
                                    parameterType2>0?
                                    <>
                                <tr><td>&nbsp;</td></tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0"}}>
                                        نام پارمتر
                                    </td>
                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", fontWeight:"bold"}}>
                                        {parameterCaption2}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0"}}>
                                        مقدار فعلی
                                    </td>
                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0"}}>
                                        {parameterValue2}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0"}}>
                                        مقدار جدید
                                    </td>
                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0"}}>
                                        <InputText value={parameterNewValue2} onChange={(e) => onParameterChanged(e.target.value, 2)} onKeyDown={util.handlePersianNumberOnKeyDown} onInput={util.handlePersianNumberOnInput} style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={4} />
                                    </td>
                                </tr>
                                    </>
                                    :
                                    <></>
                                }
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px", width:"50%"}}>جمع هزینه ها</td>
                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px", width:"50%"}}>{util.SeperatePrice(parameterPrice)}</td>
                                </tr>
                                <tr>
                                    <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px", width:"50%"}}>ارزش افزوده</td>
                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px", width:"50%"}}>{util.SeperatePrice(tax)}</td>
                                </tr>
                                <tr>
                                    <td style={{textAlign:"left", padding:"10px", border:"1px dashed #b0b0b0", borderRight:"0px", backgroundColor:"#505050", color:"#FFF", fontSize:"1.3rem"}}>جمع کل</td>
                                    <td style={{textAlign:"right", padding:"10px", border:"1px dashed #b0b0b0", borderLeft:"0px", backgroundColor:"#505050", color:"#FFF", fontSize:"1.3rem"}}>{util.SeperatePrice(purePrice)}</td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}} colSpan={2}>
                                        <div className="flex justify-content-center" style={{ direction: "ltr" }}>
                                            <Button severity="success" onClick={()=>{onContinueButtonClick()}} style={{borderRadius:"5px"}} loading={saving} iconPos="right" icon="pi pi-check">&nbsp;&nbsp;تائید و ادامه&nbsp;&nbsp;</Button>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </Col>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}